import AboutPage from "../components/about-page/about-page.component"

const About = () => (
    <>
        <AboutPage />
    </>
)

export default About;